import { render } from "./EditUserType.vue?vue&type=template&id=7affddd6&scoped=true"
import script from "./EditUserType.vue?vue&type=script&lang=js"
export * from "./EditUserType.vue?vue&type=script&lang=js"

import "./EditUserType.vue?vue&type=style&index=0&id=7affddd6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7affddd6"]])

export default __exports__